import React from 'react';
import { Car } from 'lucide-react';
import { formatCurrency } from '../../services/adminAnalyticsApi';

function formatDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', year: 'numeric' });
}

function StatusBadge({ status }) {
  const raw = String(status || 'pending').toLowerCase();
  if (['issued', 'active', 'completed', 'success', 'paid'].includes(raw)) {
    return <span className="ab-badge success">{raw === 'active' ? 'issued' : raw}</span>;
  }
  if (['pending', 'processing', 'initiated'].includes(raw)) {
    return <span className="ab-badge warning">{raw}</span>;
  }
  return <span className="ab-badge muted">{status || 'pending'}</span>;
}

const RecentTransactionsCard = ({ items = [], onViewAll, emptyMessage = 'No recent transactions' }) => (
  <div className="ab-card ab-surface-light">
    <div className="ab-card-header">
      <h3 className="ab-card-title">Recent Transactions</h3>
      {onViewAll && (
        <button type="button" className="ab-btn sm primary" onClick={onViewAll}>
          View All
        </button>
      )}
    </div>
    <div className="ab-recent-list">
      {items.length > 0 ? (
        items.map((policy, index) => {
          const ref = policy.certificate_number || policy.policy_number || policy.id || '—';
          const client = policy.insured_person || policy.insured_name || policy.clientName || policy.insuredName || '—';
          const vehicle = policy.vehicle_number || policy.vehicleReg || policy.registrationNumber;
          const premium = policy.premium || policy.premium_amount || policy.premiumAmount || 0;
          const status = policy.certificate_status || policy.status || 'pending';
          return (
            <div key={`${ref}-${index}`} className="ab-recent-item">
              <div className="ab-recent-main">
                <div className="ab-recent-ref">{ref}</div>
                <div className="ab-recent-client">{client}</div>
                <div className="ab-recent-meta">
                  {vehicle ? (
                    <span className="ab-recent-vehicle"><Car size={12} /> {vehicle}</span>
                  ) : (
                    <span className="ab-recent-vehicle muted">Vehicle not recorded</span>
                  )}
                  {policy.created_at && (
                    <span className="ab-recent-date">{formatDate(policy.created_at)}</span>
                  )}
                </div>
              </div>
              <div className="ab-recent-side">
                <div className="ab-recent-amount">{formatCurrency(premium)}</div>
                <StatusBadge status={status} />
              </div>
            </div>
          );
        })
      ) : (
        <div className="ab-empty" style={{ padding: '2.5rem 1rem' }}>{emptyMessage}</div>
      )}
    </div>
  </div>
);

export default RecentTransactionsCard;
